import React from 'react';
import { Link } from 'react-router-dom';
import { LEGAL_POLICY_LINKS } from '../content/legalPolicies';

/** Footer links for auth pages (login, register, etc.) */
export default function AuthLegalFooter() {
  return (
    <footer className="auth-legal-footer" aria-label="Legal policies">
      <nav className="auth-legal-footer__links" aria-label="Policies">
        {LEGAL_POLICY_LINKS.map(({ path, label }) => (
          <Link key={path} to={path} className="auth-legal-footer__link">
            {label}
          </Link>
        ))}
      </nav>
    </footer>
  );
}
